import React  from 'react';
import {Tag,  Badge} from 'antd';
import moment from 'moment';
import './nfe-list-item.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-duotone-svg-icons';
import {ItemBuscadorLateral} from '../../../../componentes';
const NFeListItem = (props) => {

    const {nfe, onClick, selecionada} = props;


    console.log(props);
    const getColor = (estado) => {
        switch(estado){
            case "COMPLETO":
                return "success";
            default:
                return "default";
        }
    }
    
    // let classNameSelecionado = ""
    // if(selecionada){
    //     classNameSelecionado = "selecionado";
    // }
    let tagPossuiCienciaOperacao = (<></>);
    
    if(nfe.statuCienciaOperacao === "POSSUI_CIENCIA_OPERACAO"){
        tagPossuiCienciaOperacao = (<><Tag color="success" style={{
            float: "right"
        }}><FontAwesomeIcon icon={faCheck}></FontAwesomeIcon></Tag></>);
    }

    let badgeProcessando = (<></>);
    if(nfe.estadoProcessamento !== "NENHUM"){
        badgeProcessando = (<Badge status="processing"></Badge>);
    }

    return (
        <ItemBuscadorLateral
            onClick={onClick}
            key={nfe.uuid}
            selecionado={selecionada}
            
        >
            <span className='nome'>{nfe.nome || "Desconhecido"}</span>
            <span className='chaveNFe'>Emissão: {nfe.dataEmissao ? moment(nfe.dataEmissao).format('DD-MM-YYYY HH:mm:ss'): "DESCONHECIDA"}</span>
            <span className='chaveNFe'>{nfe.chaveNFe}</span>
            <Tag color={getColor(nfe.estadoInformacao)}>{nfe.estadoInformacao.replace(/_/gm, ' ')}</Tag>
            &nbsp;{tagPossuiCienciaOperacao}&nbsp;
            {badgeProcessando}

        </ItemBuscadorLateral>


    );
}
    // <Row onClick={onClick} className={["item", classNameSelecionado]} key={nfe.uuid}>
    //     <Col >
    //     </Col>
    // </Row>

export {NFeListItem};